import O, { STORAGE_KEYS as i } from "../managers/storage-manager.js";
export function isDisabled() {
  return !!new O.ee(null, !0).jr(i.re);
}
